import axios from "axios";

// Best practice: Use constants for storage keys to prevent typos
const STORAGE_KEYS = {
  PLAN_DETAILS: "planDetails",
  EMAIL: "email",
};

/**
 * 1. Fetches plan details from the API and saves them directly to localStorage.
 */
export const fetchPlanDetails = async () => {
  try {
    const email = localStorage.getItem(STORAGE_KEYS.EMAIL);

    if (!email) {
      console.warn(
        "No email found in local storage. Cannot fetch plan details.",
      );
      return;
    }

    const response = await axios.post(
      "https://api.confidanto.com/projects-data/project-limit",
      { email },
    );

    // Format the incoming data with sensible fallbacks
    const planDetails = {
      name: response.data?.subscription || "Free Plan",
      project_limit: response.data?.project_limit ?? 6,
      expires: new Date().toISOString(), // Use ISO string for reliable JSON serialization
    };

    // Save strictly to local storage
    localStorage.setItem(
      STORAGE_KEYS.PLAN_DETAILS,
      JSON.stringify(planDetails),
    );
    console.info(
      "Plan details successfully fetched and saved to local storage.",
    );
  } catch (error) {
    console.error("Error fetching plan details:", error);
  }
};

/**
 * 2. Strictly retrieves and returns the plan details from localStorage.
 * Note: This no longer needs to be async since localStorage is synchronous.
 */
export const getPlanDetails = () => {
  try {
    const storedPlan = localStorage.getItem(STORAGE_KEYS.PLAN_DETAILS);

    if (storedPlan) {
      return JSON.parse(storedPlan);
    }

    console.info("No plan details found in local storage.");

    // Return a default fallback if nothing is in storage yet
    return {
      name: "Free Plan",
      project_limit: 6,
      expires: null,
    };
  } catch (error) {
    console.error("Failed to parse plan details from local storage:", error);
    return null;
  }
};
